import { colors, fonts } from '@grupoboticario/flora-tokens/dist/associacaoGrupoBoticario/web/ds'

export const associacaoGrupoBoticario = {
  colors,
  fonts,
}
